import { useContext, useState } from "react"
import { Div, Col, Row, Text } from "atomize"
import { toast } from "react-toastify"
import PrimaryButton from "../buttons/PrimaryButton"
import SecondaryButton from "../buttons/SecondaryButton"
import Container from "../atoms/Container"
import Paragraph from "../atoms/Paragraph"
import TextInput from "../inputs/TextInput"
import { theme } from "../settings/config"
import { profileContext } from "../providers/profile.provider"
import { inviteEntryText } from "../utils/school.utils"

// Entrare in un circolo è una cosa che si fa da sé: il consenso sta nel
// fatto che sia chi entra a digitare il codice. Nessuno si ritrova il
// circolo di un altro nell'app senza averlo chiesto.
export function JoinSchoolModal({ closeModal }) {
	const { previewSchoolInvite, joinSchoolWithCode } = useContext(profileContext)

	const [code, setCode] = useState("")
	const [preview, setPreview] = useState(null)
	const [isChecking, setIsChecking] = useState(false)
	const [isJoining, setIsJoining] = useState(false)

	const checkCode = async value => {
		setCode(value)
		setPreview(null)
		if (value.trim().length < 8) return

		setIsChecking(true)
		try {
			setPreview(await previewSchoolInvite(value))
		} catch (err) {
			toast.error(err.message || "Codice non valido", { position: "top-center" })
		} finally {
			setIsChecking(false)
		}
	}

	const handleJoin = async () => {
		setIsJoining(true)
		try {
			const { schoolName } = await joinSchoolWithCode(code)
			toast.success(`Sei entrato in ${schoolName} 🎾`, { position: "top-center" })
			closeModal()
		} catch (err) {
			toast.error(err.message || "Non sono riuscito a farti entrare", {
				position: "top-center",
			})
			setIsJoining(false)
		}
	}

	return (
		<Container>
			<Div m={{ b: "0.5rem" }} textWeight="bold" textSize="title">
				Entra in un circolo
			</Div>
			<Text textColor={theme.colors.gunmetal} m={{ b: "1rem" }}>
				Serve il codice di chi lo gestisce. I circoli in cui lavori si scelgono dall'alto,
				e quello che hai già resta dov'è.
			</Text>

			<Paragraph title="Codice">
				<TextInput
					value={code}
					placeholder="es. ABCD-2345"
					textTransform="uppercase"
					handleChange={e => checkCode(e.target.value)}
				/>
			</Paragraph>

			{isChecking && (
				<Text textSize="caption" textColor={theme.colors.text_light}>
					Controllo...
				</Text>
			)}

			{preview && (
				<Div bg={theme.colors.background} p="1rem" rounded="10px">
					<Text textSize="subheader" textWeight="bold">
						{preview.schoolName}
					</Text>
					<Text textSize="caption" textColor={theme.colors.text_light}>
						{inviteEntryText(preview, "chi ti ha invitato")}
					</Text>
				</Div>
			)}

			<Div m={{ x: "1rem" }}>
				<Row m={{ t: "1rem" }}>
					<Col p="0">
						<SecondaryButton
							m="auto"
							textColor={theme.colors.gunmetal}
							text={isJoining ? "Un attimo..." : "Indietro"}
							textSize="subheader"
							disabled={isJoining}
							action={closeModal}
						/>
					</Col>
					{!isJoining && (
						<Col p="0">
							<PrimaryButton
								m="auto"
								bg={theme.colors.primary}
								textColor="white"
								textSize="subheader"
								text="Entra"
								disabled={!preview}
								action={handleJoin}
							/>
						</Col>
					)}
				</Row>
			</Div>
		</Container>
	)
}

export default JoinSchoolModal
